module.exports = __webpack_public_path__ + "img/research-01.1ae0c4ad.jpg";